import RecordingCard from "./RecordingCard";
import type { RecordingListItem } from "../api/types";

interface Props {
  items: RecordingListItem[];
  isLoading: boolean;
  emptyText: string;
  emptyHint?: string;
  /** Batch-review mode (Recordings page). */
  selectable?: boolean;
  selectedIds?: Set<number>;
  /** Called for tiles the caller accepts; a tile is only pickable when this returns true. */
  canSelect?: (rec: RecordingListItem) => boolean;
  onToggleSelect?: (id: number) => void;
}

/** Loading skeletons → empty state → the card grid. Shared by all three list pages. */
export default function RecordingGrid({
  items,
  isLoading,
  emptyText,
  emptyHint,
  selectable,
  selectedIds,
  canSelect,
  onToggleSelect,
}: Props) {
  if (isLoading) {
    return (
      <div className="card-grid">
        {Array.from({ length: 6 }).map((_, i) => (
          <div key={i} className="rec-card skeleton-card" aria-hidden>
            <div className="rec-thumb skeleton" />
            <div className="rec-card-body">
              <div className="skeleton sk-line w70" />
              <div className="skeleton sk-line w40" />
            </div>
          </div>
        ))}
      </div>
    );
  }
  if (items.length === 0) {
    return (
      <div className="empty-state">
        <p>{emptyText}</p>
        {emptyHint && <p className="muted small">{emptyHint}</p>}
      </div>
    );
  }
  return (
    <div className="card-grid">
      {items.map((r) => {
        const pickable = Boolean(selectable && (canSelect ? canSelect(r) : true));
        return (
          <RecordingCard
            key={r.id}
            rec={r}
            selectable={selectable}
            selected={selectedIds?.has(r.id)}
            onToggleSelect={pickable ? onToggleSelect : undefined}
          />
        );
      })}
    </div>
  );
}
